<template>
    <div class="container-fluid" style="background-color: white;">
        <div class="col text-right">
            <button class="btn btn-default margin next" @click="goToBackWord">
                <icon name="backward"></icon>
                ย้อนกลับ
            </button>
            <button class="btn btn-default margin next" @click="goToCardEmployee">
                <icon name="forward"></icon>
                ถัดไป
            </button>
            <button class="btn btn-success margin"
                    @click="showConfirmModal">
                <icon name="save"></icon>
                บันทึกจบ
            </button>
            <button class="btn btn-danger margin" @click="goToEmployeeList">
                <icon name="times"></icon>
                ยกเลิก
            </button>
        </div>
        <div class="row border border-dark">
            <div style="padding: 10px">
                <h5>ลดหย่อน</h5>
                <div class="row form-group">
                    <b-col sm="5" class="col-sm-5 text-right">
                        <label>เงินพึงประเมิน ทั้งปี</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6">
                        <input type="text" class="form-control" v-model="form.tax.income_total"/>
                    </b-col>
                </div>
                <div class="row form-group">
                    <b-col sm="5" class="col-sm-5 text-right">
                        <label>หักค่าใช้จ่ายเป็นการเหมาได้ร้อยละ 50 ของเงินได้แต่รวมกันแล้วต้องไม่เกิน 100,000 บาท</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6">
                        <input type="text" class="form-control" v-model="form.tax.cost_half"/>
                    </b-col>
                </div>
                <div class="row form-group">
                    <b-col sm="5" class="col-sm-5 text-right">
                        <label>หักค่าลดหย่อนส่วนตัว</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6">
                        <input type="text" class="form-control" v-model="form.tax.cost_private"/>
                    </b-col>
                </div>
                <div class="row form-group">
                    <b-col sm="5" class="col-sm-5 text-right">
                        <label>หักค่าประกันสังคมลดหย่อนภาษีได้สูงสุด 9,000 บาท</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6">
                        <input type="text" class="form-control" v-model="form.tax.cost_social_security"/>
                    </b-col>
                </div>
                <div class="row form-group">
                    <b-col sm="5" class="col-sm-5 text-right">
                        <label>หักค่าลดหย่อนอื่นๆ (บุตร , ภรรยา)</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6">
                        <input type="text" class="form-control" v-model="form.tax.cost_other" />
                    </b-col>
                </div>
                <div class="row form-group">
                    <b-col sm="5" class="col-sm-5 text-right">
                        <label>เงินได้สุทธิทั้งปี</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6">
                        <input type="text" class="form-control" v-model="form.tax.total" disabled/>
                    </b-col>
                </div>
                <div class="row form-group">
                    <b-col sm="5" class="col-sm-5 text-right">
                        <label>ภาษีรวมทั้งปี</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6">
                        <input type="text" class="form-control" v-model="form.tax.total_tax" disabled/>
                    </b-col>
                </div>
                <div class="row form-group">
                    <b-col sm="5" class="col-sm-5 text-right">
                        <label>ภาษี/เดือน </label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6">
                        <input type="text" class="form-control" v-model="form.tax.tax_per_month" disabled/>
                    </b-col>
                </div>
                <pre style="display: none">{{calculateTax}}</pre>
            </div>
        </div>
        <!--<pre class="alert alert-danger text-left">{{form.tax}}</pre>-->
        <b-modal hide-header hide-footer ref="confirmEmp">
            <confirm-emp-modal @submit="saveEmployee">
            </confirm-emp-modal>
        </b-modal>
    </div>

</template>

<script>
    import { mapState } from "vuex"
    import DatePicker from 'vue2-datepicker'
    import confirmEmpModal from "../../../Utility/ConfirmEmpModal";

    import {
        canViewSuperAdmin
    } from "../../../../util/Permissions";
    export default {
        name: "employee-tax",
        components : { confirmEmpModal },
        props: {
            status_bar: { default: false },
        },
        data(){
          return{
              percent_tax : [],
              gap_tax : [],
          }
        },
        created(){
            if(!this.form.id && this.form.salary){
                if(this.form.salary.salary_per_day == 1){ //ต่อวัน
                    this.form.tax.income_total = parseFloat(this.form.salary.salary) * 30 * 12;
                }
                if(this.form.salary.salary_per_day == 3){ //ต่อเดือน
                    this.form.tax.income_total = parseFloat(this.form.salary.salary) * 12;
                }
            }
            this.$store.dispatch("Common/getRateTax").then(res=>{
                this.percent_tax = res.percent;
                this.gap_tax = res.gap;
            });
        },
        computed:{
            canViewSuperAdmin,
            ...mapState({
                form:state =>{
                    return state.Employee.employeeForm;
                },
                user:state=>{
                    return state.Auth.user;
                },
            }),
            calculateTax(){
                let gap = this.gap_tax;
                let tax_range = this.percent_tax;
                let sum_tax = 0;
                let index = 0;
                let income_total = this.form.tax.income_total ? this.form.tax.income_total : 0;
                let cost_haft = this.form.tax.cost_half ? this.form.tax.cost_half :0;
                let cost_private = this.form.tax.cost_private ? this.form.tax.cost_private :0;
                let cost_social_security = this.form.tax.cost_social_security ? this.form.tax.cost_social_security :0;
                let cost_other = this.form.tax.cost_other ? this.form.tax.cost_other :0;
                this.form.tax.total = parseFloat(income_total) - parseFloat(cost_haft) - parseFloat(cost_private) - parseFloat(cost_social_security) - parseFloat(cost_other);
                let total = this.form.tax.total;
                if(total > 150000){
                    for (let i=0 ;i<tax_range.length ;i++){
                        let tax = 0;
                        if(total > gap[i]){
                            tax = gap[i] * (tax_range[i] / 100);
                            total = total - gap[i];
                        }else{
                            index = i;
                            break;
                        }
                        sum_tax += parseFloat(tax);
                    }
                    let tax = total * (tax_range[index] / 100);
                    sum_tax += parseFloat(tax);
                }
                this.form.tax.total_tax = sum_tax;
                this.form.tax.tax_per_month = (parseFloat(sum_tax) / parseFloat(12)).toFixed(2);
            }
        },
        methods:{
            showConfirmModal(){
                this.$refs.confirmEmp.show();
            },
            goToEmployeeList(){
                this.$router.push({
                    name : "employee"
                })
            },
            goToBackWord(){
                this.$router.push({
                    name : "employee-information-leaveDay"
                })
            },
            goToCardEmployee(){
                this.$router.push({
                    name : "employee-information-card_employee"
                })
            },
            saveEmployee(value) {
                if (value) {
                    this.form.user_id = this.user.id;
                    this.$store.dispatch("Employee/saveEmployee", {
                        id: this.form.id,
                        data: this.form
                    });
                    this.$router.push({
                        name: "employee"
                    })
                }else{
                    this.$refs.confirmEmp.hide();
                }
            }

        }
    }
</script>

<style scoped>
    body {font-family: Arial, Helvetica, sans-serif;}
    * {box-sizing: border-box;}

    .form-inline {
        display: flex;
        flex-flow: row wrap;
        align-items: left;
    }

    .form-inline label {
        margin: 5px 10px 5px 0;
    }

    .form-inline input {
        vertical-align: middle;
        margin: 5px 10px 5px 0;
        padding: 10px;
        background-color: #fff;
        border: 1px solid #ddd;
    }

    .form-inline button {
        padding: 10px 20px;
        border: 1px solid #ddd;
        color: white;
        cursor: pointer;
    }

    .form-inline button:hover {

    }

    @media (max-width: 800px) {
        .form-inline input {
            margin: 10px 0;
        }

        .form-inline {
            flex-direction: column;
            align-items: stretch;
        }
    }
    .padding{
        padding: 20px;
    }
    .margin{
        margin: 10px;
    }
</style>
